export default "__VITE_ASSET__DN6AxIM5__"